import { Outlet } from 'react-router-dom';

import RunOutSubscriptionModal from './components/RunOutSubscriptionModal';
import { useReferralTokenCapture } from './hooks/useReferralTokenCapture';

function App() {
  useReferralTokenCapture();

  return (
    <>
      <main>
        <Outlet />
      </main>
      <RunOutSubscriptionModal />
    </>
  );
}

export default App;
